<div class="app-sidebar-user" [class.app-sidebar-user--avatar-only]="avatarOnly()">
  @if (authService.isEnabled) {
    <button
      type="button"
      class="app-sidebar-user__trigger"
      [class.app-sidebar-user__trigger--busy]="authService.isLoggingOut()"
      [attr.aria-label]="'Account menu for ' + (authService.displayName() ?? 'signed-in user')"
      aria-haspopup="menu"
      [disabled]="authService.isLoggingOut()"
      (click)="toggleAccountMenu($event)"
    >
      <span
        class="app-sidebar-user__avatar app-type-label app-tone-text-inverse"
        aria-hidden="true"
      >
        @if (authService.isLoggingOut()) {
          <app-loading-spinner size="small" [inlineRow]="true" />
        } @else {
          {{ authService.initials() }}
        }
      </span>

      <span class="app-sidebar-user__text" [attr.aria-hidden]="avatarOnly()">
        <span
          class="app-sidebar-user__name app-type-label app-tone-text-secondary"
          [attr.title]="authService.displayName() ?? undefined"
        >
          {{ authService.displayName() }}
        </span>
      </span>
    </button>

    <p-menu
      #accountMenu
      appendTo="body"
      [popup]="true"
      [model]="menuItems()"
      styleClass="app-sidebar-user-menu"
    />
  } @else {
    <div class="app-sidebar-user__static" role="status" [attr.aria-label]="authDisabledLabel">
      <div class="app-sidebar-user__avatar app-type-label app-tone-text-inverse" aria-hidden="true">
        {{ authDisabledInitials }}
      </div>
      <span class="app-sidebar-user__text" [attr.aria-hidden]="avatarOnly()">
        <span class="app-sidebar-user__name app-type-label app-tone-text-secondary">
          {{ authDisabledLabel }}
        </span>
      </span>
    </div>
  }
</div>
